import { ChevronUp, ChevronDown } from 'lucide-react'
import { cn } from '@/shared/lib/utils'

export type SortDirection = 'asc' | 'desc' | null

interface SortIndicatorProps {
  direction: SortDirection
  active: boolean
}

// Full strength at rest so a sortable header reads as one (people missed the old
// faded arrows); darkens when its header is hovered (the header carries
// `group/sort`); a sorted column shows only its direction's arrow, in the accent.
export function SortIndicator({ direction, active }: SortIndicatorProps) {
  return (
    <span
      className={cn(
        'ml-1 inline-flex flex-col items-center -space-y-1 transition-opacity',
        !active && 'text-[var(--ink-3)] group-hover/sort:text-[var(--ink)]'
      )}
    >
      <ChevronUp
        strokeWidth={active && direction === 'asc' ? 3 : 2}
        className={cn(
          'h-3.5 w-3.5',
          active && direction === 'asc' && 'text-[var(--green)]',
          active && direction === 'desc' ? 'opacity-0' : 'opacity-100'
        )}
      />
      <ChevronDown
        strokeWidth={active && direction === 'desc' ? 3 : 2}
        className={cn(
          'h-3.5 w-3.5',
          active && direction === 'desc' && 'text-[var(--green)]',
          active && direction === 'asc' ? 'opacity-0' : 'opacity-100'
        )}
      />
    </span>
  )
}
